import { environment } from '@awpmarine/core/environment';
import { escapeRegExp } from '@awpmarine/core/utils';
import { addSignalAttribute, init } from '@dash0/sdk-web';

import { env } from '@/env';
import { languageTag } from '@/lib/locale';

/**
 * Dash0 website monitoring: Core Web Vitals, page views and frontend errors. Inert when
 * `VITE_DASH0_AUTH_TOKEN` is unset.
 *
 * No `identify` here, unlike the dashboard - visitors are anonymous and a marketing site has
 * nobody to name. Audience questions (referrers, campaigns) are Plausible's job; this covers
 * whether the site is fast and error-free.
 */

// Production only to avoid data pollution.
export const enabled = typeof window !== 'undefined' && environment.production && Boolean(env.VITE_DASH0_AUTH_TOKEN);

if (enabled) {
  init({
    serviceName: 'awpmarine-website',
    endpoint: {
      url: env.VITE_DASH0_ENDPOINT,
      authToken: env.VITE_DASH0_AUTH_TOKEN!,
      dataset: env.VITE_DASH0_DATASET,
    },
    // The API is a different origin, so without a match the SDK sends no trace context and the
    // contact and newsletter posts never join the API's spans. Matched against the absolute URL.
    propagators: [{ type: 'traceparent', match: [new RegExp(`^${escapeRegExp(env.VITE_API_URL)}`)] }],
  });

  addSignalAttribute('environment', environment.name || 'unknown');
  addSignalAttribute('version', environment.sha || 'unknown');
  // The language shown, and the browser's own preference, so the two can be compared.
  addSignalAttribute('locale', languageTag());
  addSignalAttribute('browser.language', navigator.language);
}
